import LocalStorageObject from 'ember-local-storage/local/object';
import EmObject from '@ember/object';

// Separate class just for types is exported due to a class initialization change since Ember 3.13 when adding some type declarations: https://github.com/typed-ember/ember-cli-typescript/issues/1012
// this breaks storages when defining types on the actual storage class
// long-term fix is using new "declare" TypeScript keyword, to be available in ember-cli-typescript 4.0.0: https://github.com/typed-ember/ember-cli-typescript/issues/1033
export class CioSettingsLocalStorageType extends EmObject {
  showAdmin: undefined | boolean;
  environment: any;
}
export default class CioSettingsLocalStorage extends LocalStorageObject {}

CioSettingsLocalStorage.reopenClass({
  initialState() {
    return {
      showAdmin: undefined,
      environment: undefined,
    };
  },
});
